import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OrdersService {
  constructor(private readonly http: HttpClient) {}

  /* ORDER */

  createOrder(payload: any) {
    const finalUrl = `${environment.baseUrl}/orders__order`;
    return this.http.post(finalUrl, payload);
  }

  createPreOrder(payload: any) {
    const finalUrl = `${environment.baseUrl}/orders__order/pre-order`;
    return this.http.post(finalUrl, payload);
  }

  createQuotationRequest(payload: FormData) {
    const finalUrl = `${environment.baseUrl}/orders__order/quotation-request`;
    return this.http.post(finalUrl, payload);
  }

  requestGuestOrderAccess(reference: string, email: string): Observable<any> {
    return this.http.post(
      `${environment.baseUrl}/orders__order/guest-access`,
      { reference, email },
    );
  }

  getGuestOrder(token: string): Observable<any> {
    return this.http.post(
      `${environment.baseUrl}/orders__order/guest-access/lookup`,
      { token },
    );
  }

  /* USER ORDERS WITH PAYMENT STATUS */

  getUserOrders(
    page: number = 1,
    limit: number = 20,
    filter: string = 'all',
  ): Observable<any> {
    const finalUrl = `${environment.baseUrl}/payments/orders/user?page=${page}&limit=${limit}&filter=${encodeURIComponent(filter)}`;
    return this.http.get(finalUrl);
  }

  /* USER QUOTES */
  
  getUserQuotes(userId?: number, userEmail?: string, page: number = 1, limit: number = 10): Observable<any> {
    const finalUrl = `${environment.baseUrl}/orders__order/paginate?page=${page}&limit=${limit}`;
    const payload: any = {
      type: 'QUOTATION_REQUEST' // Filter by quote requests only
    };
    
    // Add userId filter if provided
    if (userId) {
      payload.userId = userId;
    }
    
    // Add userEmail for quotation requests
    if (userEmail) {
      payload.userEmail = userEmail;
    }
    
    // Debug logs removed
    
    return this.http.post(finalUrl, payload).pipe(
      tap(response => {
        // Debug log removed
      }),
      catchError(error => {
        // Error log removed
        return throwError(error);
      })
    );
  }

  /* CANCEL QUOTE */
  
  cancelQuote(quoteId: number): Observable<any> {
    const finalUrl = `${environment.baseUrl}/orders__order/${quoteId}/cancel-quote`;
    
    // Debug logs removed
    
    return this.http.patch(finalUrl, {}).pipe(
      tap(response => {
        // Debug log removed
      }),
      catchError(error => {
        // Error log removed
        return throwError(error);
      })
    );
  }

  /* DOWNLOAD QUOTE PDF */
  
  downloadQuotePDF(quoteId: number): Observable<Blob> {
    const finalUrl = `${environment.baseUrl}/orders__order/generate-quotation-pdf/${quoteId}`;
    
    // Debug logs removed
    
    return this.http.get(finalUrl, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf'
      }
    }).pipe(
      tap(response => {
        // Debug log removed
      }),
      catchError(error => {
        // Error log removed
        return throwError(error);
      })
    );
  }
}
